import Cookies from 'js-cookie';

function getFbclidParam() {
  const params = new URLSearchParams(window.location.search);
  return params.get('fbclid') || '';
}

export function createFbclidCookie() {
  const fbclidValue = getFbclidParam();
  if (fbclidValue) {
    Cookies.set('fbclid', fbclidValue, { expires: 30 });
  }
}

export default function getFbclidCookie() {
  const cookie = Cookies.get('fbclid');
  if (cookie) return cookie;
}
